
/*
  TIMI DESIGN GUIDE v1.5

  Keeps the existing v1.4 Make it yours guide and adds a
  click/tap-friendly Embroidery details disclosure.

  Details adapt to the EMBROIDERY MODES offered on each product.
  Does not alter Zepto options, pricing, print areas, or preview.
  Uses existing timi-design-guide.css for the original guide.
*/
(() => {
  'use strict';

  if (window.__timiDesignGuideV15) return;
  window.__timiDesignGuideV15 = true;

  const GUIDE_MODES = new Set([
    'text only', 'icons only', 'icon only',
    'text + icons', 'text + icon', 'upload'
  ]);
  const STYLE_ID = 'timi-design-guide-v15-fixes';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\(s\)/g, 's')
      .replace(/\s*\+\s*/g, ' + ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getButtons(wrapper) {
    return [
      ...wrapper.querySelectorAll(':scope > .pplr-drop-item')
    ];
  }

  function getModeName(button) {
    return normalize(
      button?.getAttribute('data-value') ||
      button?.textContent
    );
  }

  function getWrappers() {
    return [
      ...document.querySelectorAll(
        '.product-personalizer .pplr-wrapper'
      )
    ].filter(wrapper => {
      const names = getButtons(wrapper).map(getModeName);

      return (
        names.includes('text only') &&
        (names.includes('icons only') ||
          names.includes('icon only')) &&
        (names.includes('text + icons') ||
          names.includes('text + icon'))
      );
    });
  }

  function isPink(button) {
    const rgb = getComputedStyle(button)
      .backgroundColor
      .match(/[\d.]+/g)
      ?.slice(0, 3)
      .map(Number);

    if (!rgb || rgb.length !== 3) return false;

    return (
      Math.abs(rgb[0] - 247) < 12 &&
      Math.abs(rgb[1] - 188) < 12 &&
      Math.abs(rgb[2] - 208) < 12
    );
  }

  function selectedMode(wrapper) {
    const buttons = getButtons(wrapper);
    const selected = buttons.find(button =>
      button.classList.contains('active') ||
      button.classList.contains('selected') ||
      button.classList.contains('pplr_active') ||
      button.classList.contains('pplr_selected') ||
      button.getAttribute('aria-pressed') === 'true'
    ) || buttons.find(isPink);

    return getModeName(selected);
  }

  function isCompact(wrapper) {
    const names = getButtons(wrapper).map(getModeName);

    return (
      names.includes('text only') &&
      (names.includes('icons only') ||
        names.includes('icon only')) &&
      !names.includes('timi designs') &&
      !names.includes('upload')
    );
  }

  function makeGuide() {
    const guide = document.createElement('div');
    guide.className = 'timi-design-guide';

    guide.innerHTML = `
      <div class="timi-design-guide-heading">
        <span
          class="timi-design-guide-icon"
          aria-hidden="true"
        >✥</span>

        <div>
          <strong>Make it yours.</strong>
          <p>
            Customize your design directly on
            the product preview.
          </p>
        </div>
      </div>

      <div class="timi-design-guide-tips">
        <span class="timi-design-tip timi-guide-move">
          <span aria-hidden="true">✋</span>
          Drag to move
        </span>

        <span class="timi-design-tip timi-guide-resize">
          <span aria-hidden="true">⤢</span>
          Pull corners to resize
        </span>

        <span
          class="timi-design-tip timi-guide-reset"
          title="Use the circular arrow to reset the selected design."
        >
          <span aria-hidden="true">↺</span>
          Tap reset to start over
        </span>
      </div>
    `;

    return guide;
  }

  function getAvailableModes(wrapper) {
    return new Set(
      getButtons(wrapper).map(getModeName)
    );
  }

  function makeDetailLines(wrapper) {
    const modes = getAvailableModes(wrapper);
    const compact = isCompact(wrapper);
    const lines = [];

    lines.push(
      compact
        ? 'Keep your design within the embroidery area.'
        : 'Keep your design inside the dashed embroidery zone for your selected placement.'
    );

    const hasText = [
      'text only', 'text + icons', 'text + icon', 'arched text'
    ].some(mode => modes.has(mode));

    const hasIcons = [
      'icons only', 'icon only',
      'text + icons', 'text + icon'
    ].some(mode => modes.has(mode));

    if (hasText) {
      lines.push(
        'Text embroidery is included. Avoid making lettering too small for a clean stitch-out.'
      );
    }

    if (modes.has('timi designs')) {
      lines.push(
        'TIMI Designs are included. Select puff designs have an additional charge.'
      );
    }

    if (hasIcons) {
      lines.push(
        'Icons are $5 each. Avoid resizing icons smaller than their default size.'
      );
    }

    if (modes.has('upload')) {
      lines.push(
        'Logo uploads are $10.'
      );
    }

    if (!compact && hasText) {
      lines.push(
        'Select puff embroidery fonts have an additional charge.'
      );
    }

    return lines;
  }

  function makeDetails() {
    const details = document.createElement('details');
    details.className = 'timi-embroidery-details';

    const summary = document.createElement('summary');
    summary.className = 'timi-embroidery-details-trigger';
    summary.innerHTML = `
      <span>Embroidery details</span>
      <span class="timi-details-info" aria-hidden="true">i</span>
    `;

    const body = document.createElement('div');
    body.className = 'timi-embroidery-details-body';

    details.append(summary, body);
    return details;
  }

  function updateDetails(wrapper) {
    let details = [
      ...wrapper.children
    ].find(child =>
      child.classList.contains('timi-embroidery-details')
    );

    if (!details) {
      details = makeDetails();

      const guide = [
        ...wrapper.children
      ].find(child =>
        child.classList.contains('timi-design-guide')
      );

      if (guide) {
        wrapper.insertBefore(details, guide);
      } else {
        wrapper.appendChild(details);
      }
    }

    const lines = makeDetailLines(wrapper);
    const body = details.querySelector(
      '.timi-embroidery-details-body'
    );

    const signature = lines.join('\n');

    if (details.dataset.content !== signature) {
      body.replaceChildren();

      lines.forEach(line => {
        const paragraph = document.createElement('p');
        paragraph.textContent = line;
        body.appendChild(paragraph);
      });

      details.dataset.content = signature;
    }
  }

  function injectFixes() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
      .product-personalizer
      .timi-design-guide[hidden],
      .product-personalizer
      .timi-design-guide [hidden] {
        display: none !important;
      }

      .product-personalizer
      .timi-embroidery-details {
        grid-column: 1 / -1 !important;
        width: 100%;
        margin: 5px 0 7px !important;
        box-sizing: border-box;
      }

      .product-personalizer
      .timi-embroidery-details-trigger {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        width: max-content;
        max-width: 100%;
        padding: 5px 0;
        color: #70676b;
        font-family: inherit;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.3;
        cursor: pointer;
        list-style: none;
        user-select: none;
      }

      .product-personalizer
      .timi-embroidery-details-trigger::-webkit-details-marker {
        display: none;
      }

      .product-personalizer
      .timi-embroidery-details-trigger::marker {
        content: "";
      }

      .product-personalizer
      .timi-embroidery-details-trigger:hover {
        color: #8f182f;
      }

      .product-personalizer
      .timi-embroidery-details-trigger:focus-visible {
        outline: 2px solid #3e5e92;
        outline-offset: 3px;
        border-radius: 3px;
      }

      .product-personalizer
      .timi-details-info {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 15px;
        height: 15px;
        flex: 0 0 15px;
        border: 1px solid currentColor;
        border-radius: 50%;
        font-size: 10px;
        font-weight: 700;
        font-style: normal;
        line-height: 1;
      }

      .product-personalizer
      .timi-embroidery-details-body {
        margin: 5px 0 3px;
        padding: 11px 13px;
        border: 1px solid #e9d9d9;
        border-radius: 9px;
        background: #fbf5ea;
        color: #4f4549;
        font-family: inherit;
        font-size: 12px;
        line-height: 1.55;
      }

      .product-personalizer
      .timi-embroidery-details-body p {
        margin: 0 0 7px !important;
        padding: 0 !important;
        font-size: inherit !important;
        line-height: inherit !important;
      }

      .product-personalizer
      .timi-embroidery-details-body p:last-child {
        margin-bottom: 0 !important;
      }

      @media (max-width: 749px) {
        .product-personalizer
        .timi-embroidery-details-trigger {
          font-size: 11px;
          padding: 7px 0;
        }

        .product-personalizer
        .timi-embroidery-details-body {
          font-size: 11px;
          padding: 10px 11px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function update() {
    const wrappers = getWrappers();

    document.querySelectorAll(
      '.product-personalizer .timi-design-guide'
    ).forEach(guide => {
      if (!wrappers.includes(guide.parentElement)) {
        guide.remove();
      }
    });

    document.querySelectorAll(
      '.product-personalizer .timi-embroidery-details'
    ).forEach(details => {
      if (!wrappers.includes(details.parentElement)) {
        details.remove();
      }
    });

    wrappers.forEach(wrapper => {
      const mode = selectedMode(wrapper);
      const visible = GUIDE_MODES.has(mode);

      let guide = [
        ...wrapper.children
      ].find(child =>
        child.classList.contains('timi-design-guide')
      );

      if (!guide) {
        guide = makeGuide();
        wrapper.appendChild(guide);
      }

      guide.hidden = !visible;

      wrapper.classList.toggle(
        'timi-has-design-guide',
        visible
      );

      const compact = isCompact(wrapper);

      const moveTip = guide.querySelector(
        '.timi-guide-move'
      );

      const resizeTip = guide.querySelector(
        '.timi-guide-resize'
      );

      if (moveTip) moveTip.hidden = compact;
      if (resizeTip) resizeTip.hidden = compact;

      updateDetails(wrapper);
    });
  }

  function start() {
    injectFixes();
    update();

    let scheduled = false;

    function scheduleUpdate() {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        update();
      });
    }

    const observer = new MutationObserver(records => {
      const relevant = records.some(record => {
        const target = record.target;

        if (
          target.closest?.('.timi-design-guide') ||
          target.closest?.('.timi-embroidery-details')
        ) {
          return false;
        }

        if (
          record.type === 'attributes' &&
          (
            record.attributeName === 'class' ||
            record.attributeName === 'style'
          )
        ) {
          return !!target.matches?.(
            '.product-personalizer .pplr-drop-item'
          );
        }

        if (record.type === 'childList') {
          return (
            !!target.closest?.('.product-personalizer') ||
            [...record.addedNodes].some(node =>
              node.nodeType === 1 &&
              (
                node.matches?.('.product-personalizer') ||
                node.querySelector?.('.product-personalizer')
              )
            )
          );
        }

        return false;
      });

      if (relevant) scheduleUpdate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    document.addEventListener(
      'click',
      event => {
        if (
          event.target.closest?.(
            '.product-personalizer .pplr-drop-item'
          )
        ) {
          setTimeout(update, 100);
          setTimeout(update, 300);
        }
      },
      true
    );

    window.addEventListener('pageshow', update);

    setTimeout(update, 500);
    setTimeout(update, 1500);

    console.log('TIMI Design Guide v1.5 initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
